import { forwardRef, useEffect, useRef } from "react";

import styles from "./Search.module.scss";
import CloseIcon from "assets/x.svg";
import SearchIcon from "assets/search-icon.svg";

interface Props {
  searchIsExpanded: boolean;
  closeSearch(): void;
  id?: string;
}

const Search = forwardRef<HTMLDivElement, Props>(
  ({ closeSearch, searchIsExpanded, id }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null!);

    useEffect(() => {
      if (searchIsExpanded) {
        inputRef.current.focus({ preventScroll: true });
      }
    }, [searchIsExpanded]);

    return (
      <div className={styles.root} hidden={!searchIsExpanded} id={id} ref={ref}>
        <form
          className={styles.searchForm}
          action="https://www.theatlantic.com/search/"
          method="GET"
        >
          <SearchIcon aria-hidden={true} className={styles.searchIcon} />
          <label htmlFor="search-input" className={styles.visuallyHidden}>
            Search The Atlantic
          </label>
          <input
            id="search-input"
            type="search"
            name="q"
            placeholder="Search The Atlantic..."
            autoComplete="off"
            className={styles.searchInput}
            ref={inputRef}
          />
          <input
            type="submit"
            value="Submit Search"
            tabIndex={-1}
            className={styles.visuallyHidden}
          />
        </form>
        <div className={styles.quickLinksContainer}>
          <h3 className={styles.quickLinksHeading}>Quick Links</h3>
          <ul className={styles.quickLinksUl}>
            <li className={styles.quickLinkListItem}>
              <a
                href="https://www.theatlantic.com/category/dear-therapist/"
                className={styles.quickLink}
                data-action="quick link"
              >
                Dear Therapist
              </a>
            </li>
            <li className={styles.quickLinkListItem}>
              <a
                href="https://www.theatlantic.com/free-daily-crossword-puzzle/"
                className={styles.quickLink}
                data-action="quick link"
              >
                Crossword Puzzle
              </a>
            </li>
            <li className={styles.quickLinkListItem}>
              <a
                href="https://accounts.theatlantic.com/"
                className={styles.quickLink}
                data-action="quick link"
              >
                Manage Subscription
              </a>
            </li>
          </ul>
        </div>
        <button
          aria-label="Close Search"
          data-action="close search"
          onClick={closeSearch}
          className={styles.closeButton}
        >
          <CloseIcon className={styles.closeIcon} />
        </button>
      </div>
    );
  }
);

Search.displayName = "Search";

export default Search;
